import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-purple-700)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path d="M19 5L13 5L13 20L19 20L19 5Z" fill={textColor} />
    <path d="M11 11L5 11L5 20L11 20L11 11Z" fill={textColor} />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path
      d="M22.5601 6.47998L17.1201 6.47998L17.1201 25.52L22.5601 25.52L22.5601 6.47998Z"
      fill={textColor}
    />
    <path
      d="M14.8799 14.6401L9.43994 14.6401L9.43994 25.5201L14.8799 25.5201L14.8799 14.6401Z"
      fill={textColor}
    />
  </>
);

export const QuizChoicesIcon = createSlideIcon(Icon24x24, Icon32x32);
